import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { appStore, permissionStore } from "@/hooks";
import { FlexBox, TextButton } from "@/components/common";

/**
 * Displays artifact level action buttons.
 */
const __default__ = {
  name: "ArtifactLevelButtons",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_unref(permissionStore).isAllowed('project.edit_data'))
    ? (_openBlock(), _createBlock(_unref(FlexBox), { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_unref(TextButton), {
            text: "",
            label: "Edit Type",
            icon: "edit",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(appStore).openDetailsPanel('saveArtifactLevel')))
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})